import * as S from "@components/navbar/style/MobileNavbar.styled";
import { LogoutItem } from "@components/navbar/ui/mobile/LogoutItem";
import { MenuItem } from "@components/navbar/ui/mobile/MenuItem";
import { INavMenuItem } from "@types";
import React from "react";

interface SidebarProps {
  user: { firstname?: string; lastname?: string } | null;
  navItems: INavMenuItem[];
  openMenus: Record<string, boolean>;
  toggleMenu: (text: string) => void;
  onCloseMenu: () => void;
  onLogout: () => void;
  isOpen: boolean;
  pathname: string;
}

export const Sidebar: React.FC<SidebarProps> = ({
  user,
  navItems,
  openMenus,
  toggleMenu,
  onCloseMenu,
  onLogout,
  isOpen,
  pathname,
}) => {
  return (
    <S.Sidebar $open={isOpen}>
      <S.SidebarHeader>
        <S.SidebarUser>
          {user?.firstname} {user?.lastname}
        </S.SidebarUser>
        <S.CloseButton onClick={onCloseMenu} />
      </S.SidebarHeader>

      <S.SidebarMenu>
        {navItems.map((item, index) => (
          <MenuItem
            key={index + item.text}
            item={item}
            openMenus={openMenus}
            toggleMenu={toggleMenu}
            onCloseMenu={onCloseMenu}
            pathname={pathname}
          />
        ))}

        <LogoutItem onLogout={onLogout} />
      </S.SidebarMenu>
    </S.Sidebar>
  );
};
